document.addEventListener('DOMContentLoaded', function() {
        
    const cartDrawer = document.querySelector('#cart-drawer');
    const overlayCartDrawer = document.querySelector('.overlay__cart-drawer');
    const iconHeaderDrawerCart = document.querySelector('[data-drawer-name="cart"]');
    class closeBtnCartDrawer extends HTMLElement {
        constructor(){
            super();
            
            this.btnCartDrawer = this.querySelector('button');
            this.cartDrawer = document.querySelector('#cart-drawer');
            this.overlayCartDrawer = document.querySelector('.overlay__cart-drawer');
        }
        
        connectedCallback(){
            this.btnCartDrawer.addEventListener('click',evt => this.onClicky(evt)); 
            this.overlayCartDrawer.addEventListener('click', evt => this.onClicky(evt));
        }
        
        onClicky(evt){
            evt.preventDefault();
                    
            this.cartDrawer.classList.remove('show');
            this.overlayCartDrawer.classList.remove('show');
            document.body.style.overflow = 'auto';
        }
    }
    customElements.define('close-drawer', closeBtnCartDrawer);
    
    class updateCartDrawer extends HTMLElement {
        constructor(){
            super();
               
            this.btnsQtys = this.querySelectorAll('button');
            this.loadingDrawer = document.querySelector('.drawer-cart--loading');
        }
        
        connectedCallback(){
            this.btnsQtys.forEach(elm => elm.addEventListener('click', this.updateQuantity.bind(this)));
        }
        
        fetchConfig(type = 'json') {
            return {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
            };
        }
        
        updateQuantity(evt) {
            evt.preventDefault();
            
            this.loadingDrawer.classList.add('show');
            
            this._currentBtn = evt.currentTarget;
            
            let _sentido = this._currentBtn.getAttribute('name');
            let quantity = _sentido === 'minus' ? parseInt(this.querySelector('input').value) - 1 : parseInt(this.querySelector('input').value) + 1;
            let line = this.querySelector('.quantity__input').dataset.index;
            
            const body = JSON.stringify({
              line,
              quantity,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            });
        
            fetch(window.Shopify.routes.root + 'cart/change.js', {...this.fetchConfig(), ...{ body }})
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                
                const parsedState = JSON.parse(state);
        
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
                this.loadingDrawer.classList.remove('show');
              }).catch(() => {
                this.loadingDrawer.classList.remove('show');
            });
        }
        
        getSectionInnerHTML(html, selector) {
          return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
        }
        
        getSectionsToRender() {
          return [
            {
              id: 'cart-drawer',
              section: document.getElementById('cart-drawer').dataset.id,
              selector: '.form__cart-drawer',
            },
            {
                id: 'Header-icon',
                section: 'header',
                selector: '#Header-icon'
            }
          ];
        }
        
        
    }
    customElements.define('quantity-input', updateCartDrawer);
    
    class cartRenmove extends updateCartDrawer {
        constructor(){
            super();
            
        }
        
        connectedCallback(){
            this.querySelector('a').addEventListener('click',evt => {
                evt.preventDefault();
                
                let line = this.dataset.index;
                let quantity = 0;
                
                
                this.loadingDrawer.classList.add('show');
                
                const body = JSON.stringify({
                  line,
                  quantity,
                  sections: this.getSectionsToRender().map((section) => section.section),
                  sections_url: window.location.pathname
                });
                
                
                fetch(window.Shopify.routes.root + 'cart/change.js', {...this.fetchConfig(), ...{ body }})
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                  
                  const parsedState = JSON.parse(state);
                  
                  //this.classList.toggle('is-empty', parsedState.item_count === 0);
                  //document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
          
                  this.getSectionsToRender().forEach((section => {
                    const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                  }));

                  this.loadingDrawer.classList.remove('show');
                }).catch(() => {
                  this.loadingDrawer.classList.remove('show');
              });
                
            });
        }
    }
    customElements.define('cart-remove-button', cartRenmove);
});